import { Cookies, InternalMessageBusChannels, internalMessageBus } from "sb-resp-lib";
import { computed, action, observable, IObservableArray } from "mobx";
import { FavoriteItem } from "../../typings";
import { Event } from "../../contracts";
// 1.5 hours
const EXPIRE_TIME = 0.063;

export class FavoritesManager {
    private cookieName: string
    private favorites: IObservableArray<FavoriteItem>;

    constructor(cookieName: string) {
        this.cookieName = cookieName;
        this.favorites = observable([]);
    }

    /* istanbul ignore next */
    // Cookies cannot be tested
    protected setCookie(favoriteEvents: FavoriteItem[]) {
        const favoritesCookie = favoriteEvents.map((favoriteEvent) => favoriteEvent.stringify());
        Cookies.set(this.cookieName, favoritesCookie.join(","), { expires: EXPIRE_TIME });
    }

    /* istanbul ignore next */
    // Cookies cannot be tested
    protected getCookie(): FavoriteItem[] {
        const favoritesInCookie = Cookies.get(this.cookieName);
        let favorites = favoritesInCookie ? favoritesInCookie.split(",") : [];
        return favorites.map((favoritePair) => new FavoriteItem(favoritePair));
    }

    private emitFavoritesMessage(option: string) {
        internalMessageBus.emit(InternalMessageBusChannels.favoriteEvents[option]);
    }

    @computed get favoriteEventIds(): string[] {
        return this.favorites.map((item: FavoriteItem) => item.eventId);
    }

    @computed get favoriteSportIds(): string[] {
        return this.favorites.map((item: FavoriteItem) => item.sportId)
                             .filter((id, i, array) => array.indexOf(id) === i);
    }

    @action.bound add(eventToAdd: FavoriteItem) {
        this.favorites.push(eventToAdd);
        this.setCookie(this.favorites);
        this.emitFavoritesMessage("add");
    }

    @action.bound remove(eventToRemove: FavoriteItem) {
        this.favorites.replace(this.favorites.filter((item: FavoriteItem) => item.eventId !== eventToRemove.eventId));
        this.setCookie(this.favorites);
        this.emitFavoritesMessage("remove");
    }

    @action.bound loadFavorites() {
        this.favorites.replace(this.getCookie());
    }

    manageFavorites(event: Event) {
        const item = new FavoriteItem();
        item.setValues(event.sportId, event.id);
        this.isInFavorites(event.id) ? this.remove(item) : this.add(item);
    }

    isInFavorites(eventId: string): boolean {
        return this.favorites.some((item: FavoriteItem) => item.eventId === eventId);
    }

    @computed get getFavorites() {
        return this.favorites;
    }
}